(function ($) {
	'use strict';

	var menuSectionExpandedClass = 'menu-section--expanded';
	var mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
	var isReducedMotionPreferred = !mediaQuery || mediaQuery.matches;

	mediaQuery.addEventListener('change', function () {
		isReducedMotionPreferred = mediaQuery.matches;
	});

	function trimSlashFromUrl(url) {
		if(url.charAt(url.length - 1) === '/') {
			return url.slice(0, -1);
		}
		return url;
	}

	$.menuSection = {
		init: function initMenuSectionPlugin() {
			$('.menu-section').each(function (_, menuSectionElement) {
				var menuSection = $(menuSectionElement);
				var menuSectionNav = menuSection.find('.menu-section__nav');

				menuSection.find('.menu-section__rule').each(function(_, ruleElement) {
					var rule = $(ruleElement);
					rule.css('max-width', rule.width());
				});

				var menuButton = menuSection.find('.menu-section__button');
				menuButton.attr('aria-expanded','false');
				menuButton.on('click keydown', function (event) {
					if(event.type === 'keydown') {
						if(event.code !== 'Space') {
							return;
						}
						event.preventDefault();
					}

					var nextMenuSectionExpandedState = !menuSection.hasClass(menuSectionExpandedClass);

					menuSection.toggleClass(menuSectionExpandedClass, nextMenuSectionExpandedState);
					menuSectionNav.attr('aria-hidden', !nextMenuSectionExpandedState);
					if(nextMenuSectionExpandedState) {
						menuButton.attr('aria-expanded','true');
						var firstLink = menuSectionNav.find('a').first();
						setTimeout(function () {
							firstLink.focus();
						}, 500);

						if(isReducedMotionPreferred) {
							menuSectionNav.show();
						} else {
							menuSectionNav.slideDown(350);
						}
					} else {
						menuButton.attr('aria-expanded','false');
						if(isReducedMotionPreferred) {
							menuSectionNav.hide();
						} else {
							menuSectionNav.slideUp(350);
						}
					}
				});

				menuSection.find('.menu-section__nav-link').each(function (_, linkElement) {
					var currentUrlPath = trimSlashFromUrl(window.location.href.split('#')[0]);
					var linkHrefParts = linkElement.href.split('#');
					var linkUrlPath = trimSlashFromUrl(linkHrefParts[0]);

					if(linkHrefParts.length === 2 && linkUrlPath === currentUrlPath) {
						linkElement.href = '#' + linkHrefParts[1];
					}
				});
			});
		}
	}
})(jQuery);
